import React, {PureComponent} from "react"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"

const Wrapper = styled.div`
  padding: 30px;
`

import {Para} from "@irati/ui/src/Labels"

interface Props {
  message: string
}

class DefaultMessage extends PureComponent<Props> {
  render() {
    const {message} = this.props
    return (
      <Wrapper>
        <Para center large>
          <FormattedMessage id={message} />
        </Para>
      </Wrapper>
    )
  }
}

export default DefaultMessage
